import { Provider } from "react-redux";
import { AppRoutes } from "Routes/AppRoutes";
import store from "store/store";
import "./App.scss";

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <AppRoutes />
      </Provider>
    </div>
  );
}

export default App;
